'use strict';

module.exports = function (marty) {
  marty.Queries = require('./queries');
  marty.createQueries = require('./createQueriesClass');
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/queries/index.js
 ** module id = 578
 ** module chunks = 0
 **/